// extracted by mini-css-extract-plugin
module.exports = {"tabRow":"Level2Simple_tabRow__X-5QI","loaderAnimation":"Level2Simple_loaderAnimation__21Z04","helpLink":"Level2Simple_helpLink__qSQrd"};